import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../../../store/app'
import { useDispatch, useSelector } from 'react-redux'
import { ViewIntersetExam } from '../Utils/slice'
import { useNavigate, useParams } from 'react-router-dom'
import InterestAssessmentForm from './InterestAssessmentCommon/InterestAssessmentForm'
import { Form } from 'antd'
import PageSpinner from '../../../../../components/PageSpinner/PageSpinner'
import { setUserOptions } from '../../../../../store/AuthSlice'
import { get_users_industry } from '../../../../../config/Global'
import { AlignedGridsService } from 'ag-grid-community'

/**
 * Renders the component to  view Interest Discovery Exam.
 *
 * @return {JSX.Element} The rendered component.
 */
const InterestAssessmentView = () => {
    const dispatch: AppDispatch = useDispatch()
    const { id }: any = useParams()
    const decodedDataId = atob(id);
    const allsteps = useSelector((state: RootState) => state.WEBPROFILE.bothExamData)

    const [current, setCurrent] = useState(0);
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const steps = allsteps?.questions?.map((item: any, index: number) => ({
        key: item?.id,
        title: item?.question,
        content: item?.answers,
        question_id: item?.id,
        options: item?.answer_options,
        index: index + 1
    }));
    // const itemsPerPage = 6;

    const [itemsPerPage, setItemsPerPage] = useState<any>(6);
    const startIndex = current;
    const endIndex = current + itemsPerPage;
    const getFirstSix = steps?.slice(startIndex, endIndex);
    const lastArrayData = getFirstSix && getFirstSix[getFirstSix?.length - 1]; // for identity done btn or next btn
    const [generalQuestionLimit, setGeneralQuestion] = useState<any>(36);
    const [tierOneLimit, setTierOneLimit] = useState<any>(14);

    // For fetching question and answer for the exam 
    useEffect(() => {
        dispatch(setUserOptions()).then((res: any) => {
            // if (is_solar) {
            //     setGeneralQuestion(40)
            //     setTierOneLimit(8)
            //     setItemsPerPage(5)
            // }
            if (res?.user) {
                const userMeInfo = res.user;
                setGeneralQuestion(Number(userMeInfo?.industry?.general_questions_count));
                setTierOneLimit(Number(userMeInfo?.industry?.tier_one_questions_count));
                setItemsPerPage(11);
                dispatch(ViewIntersetExam(decodedDataId))
                    .then((data: any) => {
                        if (data.data.exam_status != 4) {
                            navigate('/dashboard');
                            return 0;
                        }
                        if (data?.data?.attends) {
                            data.data.attends.map((item: any) => form.setFieldValue(item.question_id, item?.answer))
                        }
                        setLoading(false)




                    })
                    .catch((e: any) => e)

            }
        }).catch((e: any) => e)




        // dispatch(setUserOptions()).then((res: any) => {
        //     var genQuest = generalQuestionLimit;
        //     const { is_solar } = get_users_industry(res.user);
        //     if (is_solar) {
        //         genQuest = 40;
        //         setGeneralQuestion(genQuest)
        //         setTierOneLimit(8)
        //         setItemsPerPage(5)
        //     }
        //     dispatch(ViewIntersetExam(decodedDataId))
        //         .then((res: any) => {
        //             setTierOneLimit(res.data.total_questions - genQuest);
        //             if (res?.data?.attends) {
        //                 res.data.attends.map((item: any) => form.setFieldValue(item.question_id, item?.answer))
        //             }
        //             setLoading(false)
        //         }).catch((e: any) => e).catch((e: any) => e)
        // }).catch((e: any) => e)

    }, [])

    // Button to view next 6 questions
    const nextButton = () => {
        setCurrent(current + itemsPerPage)

        if (lastArrayData?.index === steps.length) {
            navigate("/dashboard")
        }
    }

    // For scroll to the top after clicking on next button
    useEffect(() => {
        if ((document.body.clientHeight - 4) > window.innerHeight) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [nextButton])


    return !loading && allsteps ? (
        <InterestAssessmentForm
            steps={steps}
            nextButton={nextButton}
            form={form}
            current={current}
            setCurrent={setCurrent}
            type='view'
            id="InterestAssessmentFormView"
            getFirstSix={getFirstSix}
            lastArrayData={lastArrayData}
            generalQuestionsLimit={generalQuestionLimit}
            tier1QuestionsLimit={tierOneLimit}
            itemsPerPage={itemsPerPage}
        />
    ) : <PageSpinner />
}

export default InterestAssessmentView